import type { FragmentType } from 'src/gql';
import { graphql, unmaskFragment } from 'src/gql';
import { assetTitle, renderIconForAsset } from 'src/utils/asset';

import { assetSubtitle } from '@savvy/deprecated-shared/utils/portfolio';

import PortfolioItemDescriptionRow from '../views/portfolio-item-description-row';

export const PortfolioAssetDescriptionRowFragment = graphql(/* GraphQL */ `
  fragment PortfolioAssetDescriptionRow on Asset {
    ...AssetTitle
    ...RenderIconForAsset
    assetClass
    assetSubclass
    companyEquityGrantType
  }
`);

export default function PortfolioAssetDescriptionRow({
  assetFrag,
}: {
  readonly assetFrag: FragmentType<typeof PortfolioAssetDescriptionRowFragment>;
}) {
  const asset = unmaskFragment(PortfolioAssetDescriptionRowFragment, assetFrag);

  return (
    <PortfolioItemDescriptionRow
      icon={renderIconForAsset(asset)}
      title={assetTitle(asset)}
      subtitle={assetSubtitle(asset)}
    />
  );
}
